module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0055.jpg?v=f905cb58";